export const paymentProfileDe = {
  "Stripe": "Stripe",
  "Online payments via Stripe": "Online-Zahlungen über Stripe",
  "Card payments at the studio": "Kartenzahlungen vor Ort im Studio",
  "App selected payment methods": "ausgewählte Zahlungsarten",
  "Payment options": "Zahlungsoptionen",
  "Studio approval for bank detail changes": "Studio-Bestätigung für Änderungen der Bankdaten",
  "Credit card": "Kreditkarte",
  "Payment profile": "Zahlungsprofil",
  "Payment profile in own profile": "Zahlungsdaten im eigenen Profil",
  "Payment methods in the app": "Zahlungen in der App",
  "Ongoing contributions": "Mitgliedsbeiträge",
  "Pay outstanding items": "Ausgleich offener Positionen",
  "Wallet top-ups": "Guthabenaufladungen",
  "Set up online payment authorization": "Online-Zahlungsfreigabe",
  "Create authorization link": "Freigabelink erstellen",
  "Authorization link": "Freigabelink",
  "Block automatic payments": "automatische Zahlungen sperren",
  "Studio direct debit": "Lastschrift durch das Studio",
  "Provider direct debit": "Lastschrift über Zahlungsanbieter",
  "Online SEPA mandates agreed with the collecting bank": "Online-Mandate sind mit der einziehenden Bank vereinbart",
};
export const paymentProfileEn: Record<keyof typeof paymentProfileDe, string> = {
  "Stripe": "Stripe",
  "Online payments via Stripe": "Online payments via Stripe",
  "Card payments at the studio": "Card payments at the studio",
  "App selected payment methods": "Selected payment methods",
  "Payment options": "Payment options",
  "Studio approval for bank detail changes": "Studio approval for bank detail changes",
  "Credit card": "Credit card",
  "Payment profile": "Payment profile",
  "Payment profile in own profile": "Payment details in the personal profile",
  "Payment methods in the app": "Payments in the app",
  "Ongoing contributions": "Membership contributions",
  "Pay outstanding items": "Settlement of outstanding items",
  "Wallet top-ups": "Wallet top-ups",
  "Set up online payment authorization": "Online payment authorization",
  "Create authorization link": "Create authorization link",
  "Authorization link": "Authorization link",
  "Block automatic payments": "Block automatic payments",
  "Studio direct debit": "Direct debit by the studio",
  "Provider direct debit": "Direct debit through a payment provider",
  "Online SEPA mandates agreed with the collecting bank": "Online mandates have been agreed with the collecting bank",
};
